// extracted by mini-css-extract-plugin
export default {"content":"PageContentError-content-qmaXw PageContent-content-C67P9"};